module.exports = __webpack_public_path__ + "img/logo-text.d2cf6f7d.png";